import cls from './fallback.module.scss';

export const Fallback = () => {
  return <div className={cls.wrapper}></div>;
};
